export default __webpack_public_path__ + "c9098fe6a2507cb03874d50c414d8f86.svg";